import styled from 'styled-components'
import colors from 'theme/colors'
import Text from 'components.v2/Text'

export const MenuCardContainer = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin-top: 15px;

  &:hover {
    box-shadow: 0 0 5px 0 rgba(0,0,0,0.1);}
  }
`

export const MenuCardFooter = styled.div`
  background-color: ${colors['inputBackground']};
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  height: 30px;
`

export const MenuCardBody = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 100px;
  padding: 12px 15px;
  width: 300px;
`

export const MenuAddToCart = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  height: 30px;
  padding-left: 15px;
`

export const MenuPlus = styled.div`
  align-items: center;
  border-left: 1px solid rgba(0, 0, 0, 0.1)};
  display: flex;
  height: 30px;
  justify-content: center;
  margin-left: auto;
  width: 45px;
  color: ${colors['whitelabel']};
  font-weight: 300;
  font-size: 26px;
`

export const MenuImage = styled.div`
  width: 60px;
  height: 60px;
  margin-left: 15px;
  background-color: ${props => props.theme.colors.grey};
  background-image: url(${props => props.image});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`

export const MenuContent = styled.div`
  flex: 1;
`

export const Description = styled(Text)`
  margin: 5px 0 !important;
  letter-spacing: 0.5px;
`

export const Name = styled.p`
  word-break: break-word;
  overflow-wrap: break-word;

  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`
